import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { RawSequenceItemFormComponent } from '@app/components/forms/raw-sequence-item/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { RawSequenceItem, RawSequenceItemCreate } from '@app/models/raw-sequence-item.interface';
import { RawSequenceItemHelperService } from '@app/services/helpers/raw-sequence-item-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-raw-sequence-item-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        RawSequenceItemFormComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class RawSequenceItemEditPage {
  public title = 'Raw Sequence Item Edit';
  formValid = signal(false);
  formValue = signal<RawSequenceItemCreate | null>(null);
  id: number;
  rawSequenceItem$: Observable<RawSequenceItem>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private rawSequenceItemHelper: RawSequenceItemHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.rawSequenceItem$ = this.rawSequenceItemHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.rawSequenceItemHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['raw-sequence-items', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
